import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3bd31132"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "label" }
const _hoisted_2 = { class: "groups" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "groups-search-input" }
const _hoisted_5 = { class: "p-input-icon-left" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_7 = { class: "groups-content" }
const _hoisted_8 = { class: "empty-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!
  const _component_AsButton = _resolveComponent("AsButton")!
  const _component_AsBlock = _resolveComponent("AsBlock")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_GroupListItem = _resolveComponent("GroupListItem")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AsBlock, { class: "new-group-wrapper" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('group.newGroup')), 1),
        _createVNode(_component_AsButton, {
          type: _ctx.bTypes.Primary,
          label: _ctx.$t('group.newGroup'),
          onClick: _ctx.navigateToDetails
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_fa, { icon: "icon fa-plus" })
          ]),
          _: 1
        }, 8, ["type", "label", "onClick"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.isGroupOpened)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_AsBlock, { class: "groups-search" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createVNode(_component_InputText, {
                      type: "text",
                      modelValue: _ctx.search.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search.value) = $event)),
                      placeholder: _ctx.$t('groups.SearchPlaceholder'),
                      style: {"width":"100%"}
                    }, null, 8, ["modelValue", "placeholder"])
                  ])
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredGroups, (_, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: _.id
                }, [
                  _createVNode(_component_GroupListItem, {
                    modelValue: _ctx.filteredGroups[index],
                    "onUpdate:modelValue": ($event: any) => ((_ctx.filteredGroups[index]) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]))
              }), 128)),
              (!_ctx.filteredGroups || !_ctx.filteredGroups.length)
                ? (_openBlock(), _createBlock(_component_AsBlock, { key: 0 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('noData')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}